import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { SkeletonLoader } from '@frontend/design-system';

// Dimensions mirror workspace-management-grid.styles.ts — kept local so this file is self-contained.
const CARD_WIDTH = 344;
const CARD_HEIGHT = 215;

const cardStyles = css`
  box-sizing: border-box;
  width: ${CARD_WIDTH}px;
  height: ${CARD_HEIGHT}px;
  background: ${theme.colors.white};
  border: 2px solid ${theme.colors.neutral20};
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${theme.spacing(2)};
  min-width: 0;
`;

export function WorkspaceCardSkeleton() {
  return (
    <div css={cardStyles}>
      {/* Header skeleton */}
      <div
        css={css`
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          gap: ${theme.spacing(0.75)};
        `}
      >
        <SkeletonLoader width={80} height={18} />
        <SkeletonLoader width={14} height={20} />
      </div>
      {/* Count skeleton */}
      <SkeletonLoader width='35%' height={16} />
      {/* Pills skeleton */}
      <div
        css={css`
          display: flex;
          gap: ${theme.spacing(0.5)};
        `}
      >
        <SkeletonLoader width={90} height={24} />
        <SkeletonLoader width={90} height={24} />
        <SkeletonLoader width={60} height={24} />
      </div>
      {/* Divider */}
      <div
        css={css`
          height: 1px;
          background: ${theme.colors.neutral30};
          margin-top: ${theme.spacing(1)};
        `}
      />
      {/* Users skeleton */}
      <SkeletonLoader width='40%' height={16} />
    </div>
  );
}
